export default __webpack_public_path__ + "static/generative-border-light-8c2782d7055816d3c828742e759889901bf130fbe34bd8533cc2b0751cdad770.mp4";